var chunkMapping = {
	"36": [
		15033,
		20840,
		79255
	],
	"65": [
		40065
	],
	"307": [
		616,
		13617,
		20916,
		28061,
		28998,
		33362,
		36426,
		54686,
		67000,
		91099
	]
};
var idToExternalAndNameMapping = {
	"616": [
		"default",
		"./useCookies",
		75702
	],
	"13617": [
		"default",
		"./CustomError404",
		75702
	],
	"15033": [
		"default",
		"./useAuth",
		75702
	],
	"20840": [
		"default",
		"./useSessionStorage",
		75702
	],
	"20916": [
		"default",
		"./eventBus",
		75702
	],
	"28061": [
		"default",
		"./getAPIURL",
		75702
	],
	"28998": [
		"default",
		"./globalStorage",
		75702
	],
	"33362": [
		"default",
		"./i18n",
		75702
	],
	"36426": [
		"default",
		"./ErrorBoundary",
		75702
	],
	"40065": [
		"default",
		"./RemoteComponent",
		75702
	],
	"54686": [
		"default",
		"./permissionUtils",
		75702
	],
	"67000": [
		"default",
		"./NetworkOps",
		75702
	],
	"79255": [
		"default",
		"./Themes",
		75702
	],
	"91099": [
		"default",
		"./Loader",
		75702
	]
};
var idToRemoteMap = {
	"616": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"13617": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"15033": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"20840": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"20916": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"28061": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"28998": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"33362": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"36426": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"40065": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"54686": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"67000": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"79255": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	],
	"91099": [
		{
			"externalType": "script",
			"name": "OP_WEB_COMMON_SERVICE",
			"externalModuleId": 75702
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}